//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import deptSelector from '../dw-dept/component/dept-selector'

export default {
    components: {deptSelector},
    props: {
        userid: {
            type: String,
            default: ''
        }
    },
    data () {
        return {
            form:{
				pwd: '123456',
				userid: '',
                loginname: ''
			},
			pswShow: true
        }
    },
    computed: {

    },
	methods:{
		queryData: function(){
			var that = this;
			this.$get(this.getStore('sysUrl') + '/user/detail', {rowguid: this.form.userid}, function(data){
				that.form = data;
				if(!!data.userid){
					this.pswShow = false;
				}
			})
		},
		submit: function(){
			var that = this;
			this.$post(this.getStore('sysUrl') + '/user/add', this.form, function(data, res){
				ShowMsg.call(this, res.msg, 'success');
				this.cancle();
			})
		},
		cancle: function(){
            enpty_obj(this.form, ['pwd'])
			this.$emit('close');
		},
		deptChangeHandler: function(e){
			this.form.deptcode = e.deptcode;
			this.form.deptname = e.deptname;
		},

        reload() {
            this.form.userid = this.userid;
    		!!this.form.userid && this.queryData();
        }
	},
	mounted:function(){
		this.reload();
		console.log(this.userid);
	}
}
